// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Alert = require("../common/Components/Alert.bs.js");
let React = require("react");
let DialogV5 = require("../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let SystemMessages = require("../../reason/systemMessages/SystemMessages.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let SwitchToAgentProfileDialogMutation_graphql = require("../../__generated__/SwitchToAgentProfileDialogMutation_graphql.bs.js");

let convertVariables = SwitchToAgentProfileDialogMutation_graphql.Internal.convertVariables;

let convertResponse = SwitchToAgentProfileDialogMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = SwitchToAgentProfileDialogMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, SwitchToAgentProfileDialogMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, SwitchToAgentProfileDialogMutation_graphql.node, convertResponse, convertWrapRawResponse);

let Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function SwitchToAgentProfileDialog(props) {
  let onDismiss = props.onDismiss;
  let isOpen = props.isOpen;
  let match = use();
  let mutate = match[0];
  let match$1 = React.useState(() => "Idle");
  let setSubmissionStatus = match$1[1];
  let submissionStatus = match$1[0];
  let match$2 = SystemMessages.useSystemMessages();
  let addMessage = match$2.addMessage;
  if (!isOpen && submissionStatus !== "Idle") {
    setSubmissionStatus(param => "Idle");
  }
  let handleSuccess = () => {
    onDismiss();
    addMessage(SystemMessages.Message.make(undefined, "info", "Your team profile has been replaced with an agent profile.", 5000, undefined, undefined));
  };
  let submit = () => {
    setSubmissionStatus(param => "Loading");
    return mutate(undefined, undefined, undefined, undefined, (param, param$1) => {
      let switchToAgentMarketingProfile = param.switchToAgentMarketingProfile;
      if (switchToAgentMarketingProfile !== undefined) {
        if (switchToAgentMarketingProfile.__typename === "SwitchedToAgentMarketingProfile") {
          return handleSuccess();
        } else {
          return setSubmissionStatus(param => "SubmissionError");
        }
      } else {
        return setSubmissionStatus(param => "SubmissionError");
      }
    }, param => setSubmissionStatus(param => "SubmissionError"), undefined);
  };
  let tmp;
  switch (submissionStatus) {
    case "Idle" :
    case "Loading" :
      tmp = null;
      break;
    case "SubmissionError" :
      tmp = JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Alert.$$Error.make, {
          title: "There was an error updating your account. Please try again"
        })
      });
      break;
  }
  return JsxRuntime.jsx(DialogV5.make, {
    title: "Switch to agent profile",
    isOpen: isOpen,
    ariaLabel: "Switch to agent profile",
    onDismiss: onDismiss,
    size: "Large",
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("p", {
              children: "Switching to an agent profile will replace your team profile with a page designed for a single agent."
            }),
            JsxRuntime.jsx("p", {
              children: "This action will also change the URL of your profile."
            })
          ],
          className: "flex flex-col gap-3"
        }),
        tmp,
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
              onClick: param => onDismiss(),
              disabled: submissionStatus === "Loading",
              size: "medium",
              children: "Cancel"
            }),
            JsxRuntime.jsx(ButtonsV5.DangerButton.make, {
              onClick: param => {
                submit();
              },
              disabled: submissionStatus === "Loading",
              children: "Switch to agent profile"
            })
          ],
          className: "flex gap-4 justify-end"
        })
      ],
      className: "flex flex-col gap-6"
    })
  });
}

let make = SwitchToAgentProfileDialog;

exports.Mutation = Mutation;
exports.make = make;
/* commitMutation Not a pure module */
